import { type UseMutationOptions, useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import {
	type HttpAllocateImagesOptions,
	httpAllocateImages
} from '@/features/photoset/http/photoset.http'
import { MUTATION_KEYS } from '@/query-client'

export const useReallocateImages = (
	options?: Omit<
		UseMutationOptions<unknown, AxiosError, HttpAllocateImagesOptions>,
		'mutationFn' | 'mutationKey'
	>
) =>
	useMutation({
		...options,
		mutationKey: [MUTATION_KEYS.ALLOCATE_IMAGES],
		mutationFn: httpAllocateImages
	})
